module.exports = __webpack_public_path__ + "img/portrait-060.80c324bd.jpg";